import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const EditspeakersSlice = createSlice({
  name: 'Editspeakers',
  initialState,
  reducers: {
    Edit_speakers_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Edit_speakers_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Edit_speakers_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Edit_speakers_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {Edit_speakers_request, Edit_speakers_success, Edit_speakers_failure, Clear_Edit_speakers_Check } = EditspeakersSlice.actions

export default EditspeakersSlice.reducer